<template>
  <div class="lesson-banner">
    <div class="lesson-title">
      <div class="tit">{{product.name}}</div>
      <p v-if="signNum > 0">还剩{{ signNum }}个名额</p>
      <p v-else>名额已满</p>
    </div>
    <div class="p-images l-images">
      <swiper 
        :config="swiper"
        :paginateCls="`${swiper.paginateCls}`">
        <div class="swiper-slide" v-if="product.videos.length" v-for="(video, index) in product.videos">
          <div class="product-video" :class="'p' + index">
            <beast-video
              :wrap="'p' + index"
              :isHeight="true"
              :poster="video.thumbnailUrl"
              :autoplay="false"
              :source="video.url"
              :controls="true"
            />
          </div>
        </div>
        <div v-for="item in product.images" class="swiper-slide">
          <beast-image :src="item" />
        </div>
      </swiper>
    </div>
  </div>
</template>

<script>
import Swiper from '@/swiper/swiper-4.4.6/index.vue'
import BeastImage from '@/components/image/'
import BeastVideo from '@/components/video/'

export default {
  props: {
    product: Object
  },

  components: {
    Swiper,
    BeastImage,
    BeastVideo
  },

  data () {
    return {
      signNum: 0, // 已报名人数
      swiper: {
        pagination: {
          el: '.swiper-pagination', 
          type: 'fraction',
        },
        paginationClickable: true,
        spaceBetween: 30,
        centeredSlides: true,
        paginateCls: { 'number-paginate': true },
        // paginateCls: 'number-paginate',
        // autoplay: 3000,
        autoplayDisableOnInteraction: false
      }
    }
  },

  created () {
    this.init()
  },

  methods: {
    init () {
      const {
        stock
      } = this.product

      // this.signNum = stock.total - stock.left
      this.signNum = stock.left
    }
  }
}
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// product-banner.vue?5544de96